import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import ListaUfService from "./listaUfService"
import FormList from 'base/FormList'

export default function ListaUfList() {

    const [service, setService] = useState()
    const toast = useRef(null)

    if (!service) {
        setService(new ListaUfService())
    }

    const searchData = {
        pkName: 'codigo_liuf',
        dsName: 'descricao_liuf',
        mainField: { name: 'descricao_liuf', label: 'Descrição' },
        advFields: [
            { name: 'codigo_liuf', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_liuf', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_liuf" sortable header="Código"></Column>
            <Column field="descricao_liuf" sortable header="Descrição" style={{ whiteSpace: 'normal' }}></Column>
        </FormList >
    )
}
